import { user } from 'helper/currentUser';
import { NarrationStateEnum } from 'appConsts/narrationStateEnum';

let narrationState = {};
// const user = new CurrentUser();
let seekableFlag = false;
export default class WistiaEventsdHelper {
  constructor(playerComponent, videoData) {
    this._p = playerComponent;
    this.videoData = videoData;
    this.updateSeekData(videoData.allowSeekAhead, videoData.initialSeekableLength);

    this.videoSecondsChangeTimer = null;
    this.destroyed = false;
  }

  updateBlockPerformance(videoLength, videoWatchedLength) {
    this._p.props.updateVideoData &&
      this._p.props.updateVideoData({ videoLength, videoWatchedLength });
  }

  updateSeekData(allowSeekAhead, initialSekableLength) {
    this._p.seekData = {
      seekable: allowSeekAhead || false, // seekable need to set true for start video where user has left
      seekableLength: initialSekableLength || 0
    };
  }

  getVideoPreviousTimeAndSetStartTime(userId) {
    if (!this._p.seekData.seekable) {
      this._p.seekData.seekable = true;
      seekableFlag = true;
    }
    const mediaDurations = JSON.parse(localStorage.getItem(`${userId}_mediaDuration`));
    if (mediaDurations) {
      narrationState = {
        ...mediaDurations
      };
      const shouldSetTime =
        this._p.props.completionStatus && this._p.props.completionStatus !== 'NOT_ATTEMPTED';
      const previousTime = mediaDurations[this.videoData.videoId];
      if (!shouldSetTime) {
        this.setCurrentVideoTimeToLocalStorage(this.videoData.videoId); // sets the time to 0 in localstorage
      }
      if (previousTime && shouldSetTime) {
        this.video.time(previousTime - NarrationStateEnum.mediaBufferState);
      }
    }
  }

  videoReady() {
    // console.log(this, arguments);
    this.video = this._p.handle;
    const userId = user.id();
    this.getVideoPreviousTimeAndSetStartTime(userId);
    /* this.updateSeekData(
      this._p.props.allowSeekAhead,
      this._p.props.initialSeekableLength
    ); */
    this.video && this.attachEvents();
  }

  /* videoChanged() {
    this.updateSeekData(
      this._p.props.allowSeekAhead,
      this._p.props.initialSeekableLength
    );
  } */

  videoSeeked = (currentTime, lastTime) => {
    if (this.destroyed) return this.video.unbind;
    // console.log(this._p.seekData.seekable, this._p.seekData.seekableLength, !this._p.seekData.seekable && this._p.seekData.seekableLength !== null && !Number.isNaN(this._p.seekData.seekableLength) && currentTime > this._p.seekData.seekableLength);
    if (
      !this._p.seekData.seekable &&
      this._p.seekData.seekableLength !== null &&
      !Number.isNaN(this._p.seekData.seekableLength) &&
      currentTime > this._p.seekData.seekableLength
    ) {
      clearTimeout(this.videoSecondsChangeTimer);
      this.video.time(this._p.seekData.seekableLength || 1);
    }
  };

  videoSecondsChange = seconds => {
    if (seekableFlag) {
      this._p.seekData.seekable = false;
      seekableFlag = false;
    }
    this.setCurrentVideoTimeToLocalStorage(this.videoData.videoId);
    // console.log(this._p.seekData);
    if (this.destroyed) return this.video.unbind;
    // console.log('secondchange:', seconds);
    const performanceWatched = this._p.props.blockPerformance.videoWatchedLength;
    const seekable = this._p.seekData.seekable;
    let seekableLength = this._p.seekData.seekableLength;

    this.videoSecondsChangeTimer = setTimeout(() => {
      if (!seekable) {
        // console.log('seconds change', seconds);
        seekableLength = seekableLength < seconds ? seconds : seekableLength;
        this.updateSeekData(seekable, seekableLength);
      }
      this.updateBlockPerformance(
        this.video && this.video.duration(),
        performanceWatched > seconds ? performanceWatched : seconds
      );
    }, 500);
  };

  attachEvents() {
    this.detachEvents();
    window.videoRef = this.video;
    this.video.bind('seek', this.videoSeeked);
    this.video.bind('playbackratechange', playbackRate => {
      console.log('The playback rate is now ' + playbackRate + 'x.');
      localStorage.setItem('wistiaPlayerPlaybackRate', playbackRate);
    });
    this.video.bind('secondchange', this.videoSecondsChange);
  }

  detachEvents() {
    this.video && this.video.unbind('seek', this.videoSeeked);
    this.video && this.video.unbind('secondchange', this.videoSecondsChange);
  }

  destroy() {
    this._p.seekData = {};
    this.destroyed = true;
    this.detachEvents();
    this.video = null;
  }

  setCurrentVideoTimeToLocalStorage(videoId) {
    const currentVideoTime = this.video.time();
    narrationState[videoId] = currentVideoTime;
    if (!(this._p.props && this._p.props.editable) && !this._p.props.preview) {
      localStorage.setItem(`${user.id()}_mediaDuration`, JSON.stringify(narrationState));
    }
  }
}
